import { SilverFormComponentBaseProps } from '@decisions/server/Decisions/Silverlight/UI/Forms';
import { FileInfo } from '@decisions/server/Silverdark/Components/FileInfo';
import { SilverContainerBaseProps } from '@decisions/server/Silverdark/Designers/Forms/Containers';
import { IUploadedFileInfo } from 'components/FileLoader/Upload/FileInfo';
import { SilverContainerBasePropsWithChildren } from '../../formHostTypes';
import { isContainer } from '../../utils/FormHostUtils';
import { BaseFormInSessionInstruction } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Execution/BaseFormInSessionInstruction';
import { FlowExecutionStateInstruction } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Execution/FlowExecutionStateInstruction';
import { isNullOrWhitespace } from 'utils/StringUtils';

export const showControlNotSupportedMessage = (controlName: string): string => {
  return `${controlName} is not supported on mobile.`;
};

export const getFileStreamUrl = (
  formSessionId: string,
  componentId: string,
  fileId: string,
  downloadFile: boolean = true
): string => {
  if (!formSessionId || !componentId || !fileId) return '';
  fileId = encodeURIComponent(fileId);
  return `${Decisions.DataTypes.baseURL}FormService/JS/GetFileStream?formSessionInfoId=${formSessionId}&componentId=${componentId}&fileId=${fileId}&downloadFile=${downloadFile}`;
};

export function getUploadedFileInfo(files: FileInfo[]) {
  return (files || []).map(
    file =>
      ({
        fileId: file.Id,
        fileName: file.FileName,
        fileSize: file.ContentLength,
      } as IUploadedFileInfo)
  );
}

export function getSingleUploadedFileInfo(file: FileInfo | undefined) {
  if (file) {
    return {
      fileId: file.Id,
      fileName: file.FileName,
      fileSize: file.ContentLength,
    } as IUploadedFileInfo;
  }
  return undefined;
}

export function getControls(rootContainer?: SilverContainerBaseProps) {
  let controls: SilverFormComponentBaseProps[] = [];
  const addControls = (container?: SilverContainerBasePropsWithChildren) => {
    if (container) {
      controls.push(container);
      for (let component of container.children) {
        if (isContainer(component)) {
          addControls(component.child as SilverContainerBasePropsWithChildren);
        } else if (component.child) {
          controls.push(component.child);
        }
      }
    }
  };
  addControls(rootContainer as SilverContainerBasePropsWithChildren);
  return controls;
}

export function updateUrlByInstruction(currentInstruction?: FlowExecutionStateInstruction) {
  if (!currentInstruction) {
    return;
  }
  const currentLocation = window.location.href;
  const baseFormInstruction = currentInstruction as BaseFormInSessionInstruction;

  var path = currentLocation.split('?')[0];
  if (!path.match('/$')) {
    path += '/';
  }
  var params = window.location.search.replace('?', '').split('&'); // Get all the parameters.
  var flowid = baseFormInstruction.FlowId;
  if (isNullOrWhitespace(flowid)) {
    for (var i = 0; i < params.length; i++) {
      if (params[i]) {
        if (params[i].toLowerCase().indexOf('flowid=') >= 0) {
          flowid = params[i].split('=')[1];
        }
      }
    }
  }
  if (isNullOrWhitespace(flowid) === false) {
    path += '?FlowId=' + flowid;
  }
  if (baseFormInstruction.FlowTrackingId) {
    if (path.indexOf('?') > 0) path += '&';
    else path += '?';
    path += `FlowTrackingId=${baseFormInstruction.FlowTrackingId}`;
  }
  if (baseFormInstruction.StepTrackingId) {
    if (path.indexOf('?') > 0) path += '&';
    else path += '?';
    path += `StepTrackingId=${baseFormInstruction.StepTrackingId}`;
  }

  for (var j = 0; j < params.length; j++) {
    if (params[j]) {
      if (
        params[j].toLowerCase().indexOf('flowid=') < 0 &&
        params[j].toLowerCase().indexOf('flowtrackingid=') < 0 &&
        params[j].toLowerCase().indexOf('steptrackingid=') < 0
      ) {
        path += '&' + params[j];
      }
    }
  }

  var pageTitle = document.title;
  window.history.replaceState({ FlowID: flowid }, pageTitle, path);
}

export const FormUtils = { updateUrlByInstruction };
